import type { ReactElement } from 'react';
import { cx } from './cx';
import s from './StatusPill.module.css';

/** info · waiting · done · neutral · problem. The colour always comes with a word. */
export type StatusTone = 'info' | 'waiting' | 'done' | 'neutral' | 'problem';

const TONE: Record<StatusTone, string | undefined> = {
  info: s.info,
  waiting: s.waiting,
  done: s.done,
  neutral: s.neutral,
  problem: s.problem,
};

export interface StatusPillProps {
  tone: StatusTone;
  /** The status in words ("Paid", "Election due Oct 21"). Status is never shown by colour alone. */
  label: string;
  size?: 'sm' | 'md';
  className?: string;
}

/** A status word on its colour, e.g. "With the Stock Admin team". Also used for role tags. */
export function StatusPill({ tone, label, size = 'md', className }: StatusPillProps): ReactElement {
  return <span className={cx(s.pill, TONE[tone], size === 'sm' && s.sm, className)}>{label}</span>;
}
